import { Info, AlertTriangle, Lightbulb, AlertCircle } from "lucide-react";
import { ReactNode } from "react";

type CalloutType = "info" | "warning" | "tip" | "danger";

interface CalloutProps {
  type?: CalloutType;
  title?: string;
  children: ReactNode;
}

const variants: Record<CalloutType, { icon: ReactNode; classes: string; titleClass: string }> = {
  info: {
    icon: <Info size={15} />,
    classes: "bg-blue-dim border-blue/20 text-blue",
    titleClass: "text-blue",
  },
  warning: {
    icon: <AlertTriangle size={15} />,
    classes: "bg-amber-dim border-amber/20 text-amber",
    titleClass: "text-amber",
  },
  tip: {
    icon: <Lightbulb size={15} />,
    classes: "bg-primary-dim border-primary-border text-primary-text",
    titleClass: "text-primary-text",
  },
  danger: {
    icon: <AlertCircle size={15} />,
    classes: "bg-red-dim border-red/20 text-red",
    titleClass: "text-red",
  },
};

export function Callout({ type = "info", title, children }: CalloutProps) {
  const v = variants[type];
  return (
    <div
      role="note"
      aria-label={title ?? type}
      className={`flex gap-3 rounded-lg border px-4 py-3 my-5 text-sm ${v.classes}`}
    >
      <span className="mt-0.5 shrink-0" aria-hidden="true">
        {v.icon}
      </span>
      <div className="leading-relaxed">
        {title ? (
          <p className={`font-medium mb-1 ${v.titleClass}`}>{title}</p>
        ) : (
          <span className="sr-only">{type}</span>
        )}
        {children}
      </div>
    </div>
  );
}
